module.exports = __webpack_public_path__ + "img/CNAS.4bd7a733.webp";